'use client';

import { Grid, GridItem, Box, Flex } from '@chakra-ui/react';
import React from 'react';

interface OrderModalLayoutProps {
  headerLeft: React.ReactNode;    // a1 – event title & time
  headerRight: React.ReactNode;   // a2 – "Order Summary"
  tickets: React.ReactNode;       // b1 – ticket selector
  orderList: React.ReactNode;     // b2 – scrollable list ONLY
}

export const OrderModalLayout = ({
  headerLeft,
  headerRight,
  tickets,
  orderList,
}: OrderModalLayoutProps) => {
  return (
    <Grid
      templateRows="auto 1fr"
      templateColumns="3fr 2fr"
      h="100%"
      minH="400px"
      maxH="80vh"
      w="100%"
      gap={0}
    >
      {/* ───────────── Row A ───────────── */}
      {/* a1 */}
      <GridItem colSpan={1} borderBottom="1px solid" borderColor="gray.200">
        <Box p="4">
          {headerLeft}
        </Box>
      </GridItem>

      {/* a2 */}
      <GridItem colSpan={1} borderBottom="1px solid" borderColor="gray.200" bg="white">
        <Flex justify="center" align="center" h="100%" p="4">
          {headerRight}
        </Flex>
      </GridItem>

      {/* ───────────── Row B ───────────── */}
      {/* b1 */}
      <GridItem 
        colSpan={1} 
        borderRight="1px solid" 
        borderColor="gray.200" 
        p="4"
        minH="200px"
        maxH="60vh"
        overflowY="auto"
      >
        {tickets}
      </GridItem>

      {/* b2 (scrollable list) */}
      <GridItem 
        colSpan={1} 
        borderLeft="1px solid" 
        borderColor="gray.200" 
        bg="gray.50" 
        p="4"
        minH="200px"
        maxH="60vh"
        overflowY="auto"
      >
        {orderList}
      </GridItem>
    </Grid>
  );
};